// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SelectDeskWorkingDays_checkbox__1eqrY"};